/**
 * SIMODE API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CellData } from './cellData';


export interface HeatmapPeriodResponse { 
    AreaId: string;
    Timestamp?: string | null;
    TotalTimesteps?: number | null;
    Width?: number | null;
    Height?: number | null;
    CellsX?: number | null;
    CellsY?: number | null;
    Cells: Array<Array<CellData>>;
}

